import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'

export default {
  id: 'image',
  name: 'image',
  type: 'standard',
  moduleName: 'editor_module_image',
  hide: true,
  dataSet: {
    mods: 'image',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'image',
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: columnDetail.link,
          border: columnDetail.border,
          background: columnDetail.background,
          upload: columnDetail.upload,
          radius: columnDetail.radius
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
